module.exports = __webpack_public_path__ + "085ea4f1c5d65b47c044feed38f41cad.pdf";